import DirectSecureTransferLayout from '../components/layouts/DirectSecureTransferLayout.vue'
import DirectSecureTransferIndexPage from '../pages/DirectSecureTransferIndexPage.vue'

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
  {
    path: '/direct-secure-transfer',
    name: 'direct-secure-transfer.root',
    component: DirectSecureTransferLayout,
    meta: {
      requiresAuth: true,
      title: 'directSecureTransfer.nav.title',
      layout: 'Authenticated',
    },
    children: [
      {
        path: '',
        name: 'DirectSecureTransferIndexPage',
        component: DirectSecureTransferIndexPage,
      },
      {
        path: ':room',
        name: 'DirectSecureTransferRoomPage',
        component: DirectSecureTransferIndexPage,
      },
    ],
  },
]
